import { Button } from "@msuite/ui/button";
import type { Disclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";

/** Props Interface */
interface SubstitutionPlanFormMenuProps {
	unansweredDisclosure: Disclosure;
}

export function SubstitutionPlanFormMenu({ unansweredDisclosure }: SubstitutionPlanFormMenuProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Button
			onClick={unansweredDisclosure.onToggle}
			variant="primary"
			icon={<Icon name={unansweredDisclosure.isOpen ? "Funnel" : "FunnelX"} />}
			withPing={unansweredDisclosure.isOpen}
		>
			{t("substitutions.show_unanswered_items_only")}
		</Button>
	);
}
